import React, { useState, useEffect } from 'react';
import '../style/Tabs.css';
import { fetchSeasonTeamData } from '../util/api/requests';
import MatchesDataTable from '../modules/datatables/MatchesDataTable';
import { getUrlVars, renderSpinner } from '../util/util';

const TeamDetails = () => {
  const [seasonTeamData, setSeasonTeamData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const teamId = getUrlVars()['team_id'];
        const seasonId = getUrlVars()['season_id'];
        const teamData = await fetchSeasonTeamData(teamId, seasonId);
        if (!teamData) return;

        setSeasonTeamData({
          teamData,
          team: teamId,
          season: seasonId,
        });
      } catch (error) {
        console.error('Error fetching team season data:', error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  if (isLoading) {
    return renderSpinner();
  }

  if (!seasonTeamData) {
    return null;
  }

  const { teamData } = seasonTeamData;

  return (
    <div>
      {teamData && (
        <div>
          <p>Võistkond: {teamData.name}</p>
          <p>Mängud</p>
          <MatchesDataTable
            matches={teamData.matches}
            currentTeamName={teamData.name}
          />
        </div>
      )}
    </div>
  );
};

export default TeamDetails;
